<template>
  <div v-loading="!dataList">
    <!-- NOTE: 空数据情况: 开发人员根据业务调整 -->
    <template v-if="total == 0 && !isSearch">
      <StdNullPage text="暂无领取记录" :nullType="'nullData'"></StdNullPage>
    </template>

    <!-- 非空数据情况 -->
    <template v-else>
      <!-- NOTE: 搜索栏: 开发人员根据业务调整  -->
      <StdSearchBar v-model="keyword" placeholder="请输入用户昵称" @search="handleSearch">
        <vh-button size="medium" type="primary" round @click="exportRcord" v-if="source == 'admin'">
          导出明细
        </vh-button>
        <vh-button size="medium" type="text" round plain @click="handleSearch">刷新数据</vh-button>
      </StdSearchBar>

      <!-- NOTE: 表格数据: 开发人员根据业务调整  -->
      <vh-table :data="dataList" ref="table" style="width: 100%">
        <template slot="empty">
          <StdNullPage text="暂未搜索到您想要的内容" :nullType="'search'"></StdNullPage>
        </template>

        <vh-table-column label="用户名称" width="200">
          <template slot-scope="scope">
            <vh-tooltip effect="dark" placement="top-start" :content="scope.row.user_nickname">
              <div class="custom-tooltip-content">{{ scope.row.user_nickname }}</div>
            </vh-tooltip>
          </template>
        </vh-table-column>
        <vh-table-column prop="received_at" label="领取时间">
          <template slot-scope="scope">
            {{ scope.row.received_at }}
          </template>
        </vh-table-column>
        <vh-table-column prop="user_join_id" label="参会ID">
          <template slot-scope="scope">{{ scope.row.user_join_id }}</template>
        </vh-table-column>
        <vh-table-column prop="third_user_id" label="三方用户ID">
          <template slot-scope="scope">
            {{ scope.row.third_user_id || '-' }}
          </template>
        </vh-table-column>
        <vh-table-column prop="user_email" label="邮箱">
          <template slot-scope="scope">
            {{ scope.row.user_email || '-' }}
          </template>
        </vh-table-column>
      </vh-table>
      <!-- NOTE: 分页: 开发人员根据业务调整  -->
      <StdPagination
        :total="total || 0"
        :page-size="pagination.limit"
        :currentPage="pagination.pageNo"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </template>
  </div>
</template>

<script>
  import { tableCellTooltip } from '@vhcl/ui-console';
  import { StdNullPage, StdSearchBar, StdPagination } from '@vhcl/ui-console';
  import { getRcordList, exportRcord } from '../common/api';
  export default {
    mixins: [tableCellTooltip],
    components: {
      StdNullPage,
      StdSearchBar,
      StdPagination
    },
    props: {
      webinarId: {},
      rewardId: {},
      type: {},
      source: {
        default: 'admin' //live:发起端，admin:控制台
      }
    },
    data() {
      return {
        isNoData: false,

        keyword: '',
        multipleSelection: [],
        dataList: '',
        total: 0, // 总数量
        isEmpty: false,
        selectId: '',
        // 分页参数
        pagination: {
          limit: 10,
          pageNo: 1
        },
        isSearch: false
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      handleSearch() {
        console.log('======ok===');
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      // 翻页事件
      handleCurrentChange(current) {
        this.pagination.pageNo = current; //当前页码
        this.fetchData();
      },
      // 每页条数改变时触发
      handleSizeChange(limit) {
        this.pagination.limit = limit;
        this.pagination.pageNo = 1;
        this.fetchData();
      },
      // 模拟请求数据
      fetchData: async function () {
        // this.loading = true;
        this.keyword = this.keyword.trim();
        const res = await getRcordList({
          webinar_id: this.webinarId,
          nickname: this.keyword,
          reward_id: this.rewardId,
          pos: (this.pagination.pageNo - 1) * this.pagination.limit,
          limit: this.pagination.limit
        });
        this.isSearch = this.keyword.trim() != '';
        if (res.code == 200) {
          this.dataList = res.data.list;
          this.total = res.data.total;
        }
      },
      exportRcord() {
        exportRcord({
          reward_id: this.rewardId,
          nickname: this.keyword,
          webinar_id: this.webinarId
        }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '导出成功，请去下载中心下载',
              type: 'success'
            });
          }
        });
      },
      handleCommand({ cmd, row }) {
        console.log(dataJson);
      }
    }
  };
</script>
